import { BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';
import { BaseService, ServiceLike } from './service';

export class MemoryService<T> extends BaseService {
  constructor(initialState: T, ...dependencies: ServiceLike[]) {
    const state$ = new BehaviorSubject(initialState);

    super(...dependencies, { changes$: state$.pipe(skip(1)) });

    this.state$ = state$;
  }

  private readonly state$: BehaviorSubject<T>;

  get state() {
    return this.state$.getValue();
  }

  setState(newState: T) {
    this.state$.next(newState);
  }
}
